/**
 * @generated SignedSource<<ec79b13389a954e3290c578c682ba9ec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DislikeModal_meetingRecording$data = {
  readonly activeSummary: {
    readonly feedback: {
      readonly dontLikeTheTone: boolean;
      readonly id: string;
      readonly missingInformation: boolean;
      readonly notFactuallyCorrect: boolean;
      readonly other: boolean;
      readonly otherFeedback: string | null;
    } | null;
    readonly id: string;
  } | null;
  readonly canRegenerateSummary: boolean;
  readonly id: string;
  readonly " $fragmentType": "DislikeModal_meetingRecording";
};
export type DislikeModal_meetingRecording$key = {
  readonly " $data"?: DislikeModal_meetingRecording$data;
  readonly " $fragmentSpreads": FragmentRefs<"DislikeModal_meetingRecording">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DislikeModal_meetingRecording",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canRegenerateSummary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingRecordingSummary",
      "kind": "LinkedField",
      "name": "activeSummary",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "MeetingRecordingPromptFeedback",
          "kind": "LinkedField",
          "name": "feedback",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "missingInformation",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "notFactuallyCorrect",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "dontLikeTheTone",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "other",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "otherFeedback",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MeetingRecording",
  "abstractKey": null
};
})();

(node as any).hash = "2a4c79b460d99b66642ee0c2fdea3cc4";

export default node;
